import { FileMimeType } from '../../../types';

export type MarketingResource = {
  title: string,
  description: string,
  fileName: string,
  format: FileMimeType,
};

export const MARKETING_RESOURCES_CATALOGUE: MarketingResource = {
  title: 'Catalogo Materiali & Attivazioni Locali',
  description: 'Scarica il catalogo dei materiali di brand e dei gadget che puoi richiedere per le tue attivazioni locali.',
  fileName: 'Catalogo Materiali & Attivazioni Locali',
  format: FileMimeType.PDF,
};

export const EXTRA_PACKAGES_FLYER: MarketingResource = {
  title: 'Flyer pacchetti extra',
  description: 'Stampa e condividi con i tuoi clienti il volantino di presentazione dei pacchetti extra per chi vende casa.',
  fileName: 'Flyer - Pacchetti Extra',
  format: FileMimeType.PDF,
};

export const EXTRA_PACKAGES_WITH_PREMIUM_VISIBILITY_FLYER: MarketingResource = {
  title: 'Flyer pacchetti extra',
  description: 'Stampa e condividi con i tuoi clienti il volantino di presentazione dei pacchetti extra per chi vende casa.',
  fileName: 'Flyer - Pacchetti Extra Visibilita Premium',
  format: FileMimeType.PDF,
};

export const PAPER_COMPANY_PRESENTATION: MarketingResource = {
  title: 'Presentazione Dove.it - Cartacea',
  description: 'Stampa e condividi con i venditori la presentazione dei servizi Dove.it',
  fileName: 'Presentazione venditori Dove.it - Cartacea',
  format: FileMimeType.PDF,
};

export const DIGITAL_COMPANY_PRESENTATION: MarketingResource = {
  title: 'Presentazione Dove.it - Digitale',
  description: 'Condividi con i venditori la presentazione dei servizi Dove.it',
  fileName: 'Presentazione venditori Dove.it - Digitale',
  format: FileMimeType.PDF,
};

export const PRINT_CONSTRUCTOR_PRESENTATION: MarketingResource = {
  title: 'Presentazione Dove.it per costruttori - Stampa',
  description: 'Stampa e condividi con i costruttori la presentazione dei servizi Dove.it',
  fileName: 'Presentazione Dove.it per Costruttori - stampa',
  format: FileMimeType.PDF,
};

export const DIGITAL_CONSTRUCTOR_PRESENTATION: MarketingResource = {
  title: 'Presentazione Dove.it per costruttori - Digitale',
  description: 'Condividi con i costruttori la presentazione dei servizi Dove.it',
  fileName: 'Presentazione Dove.it per Costruttori - digitale',
  format: FileMimeType.PDF,
};

export const RECRUITING_SOCIAL_POSTS: MarketingResource = {
  title: 'Contenuti social recruiting',
  description: 'Scarica i contenuti social per il recruiting',
  fileName: 'Contenuti Social Recruiting',
  format: FileMimeType.ZIP,
};

export const SELLERS_SOCIAL_POSTS: MarketingResource = {
  title: 'Contenuti social venditori',
  description: 'Scarica i contenuti social per i venditori',
  fileName: 'Contenuti Social Venditori',
  format: FileMimeType.ZIP,
};

export const SHOWCASE_LANDSCAPE_RESOURCE: MarketingResource = {
  title: 'Contenuti vetrina agenzia - Versione verticale',
  description: 'Scarica i contenuti per la vetrina della tua agenzia - Versione verticale',
  fileName: 'Contenuti Espositori Vetrina - Verticali',
  format: FileMimeType.ZIP,
};

export const SHOWCASE_PORTRAIT_RESOURCE: MarketingResource = {
  title: 'Contenuti vetrina agenzia - Versione orizzontale',
  description: 'Scarica i contenuti per la vetrina della tua agenzia - Versione orizzontale',
  fileName: 'Contenuti Espositori Vetrina - Orizzontali',
  format: FileMimeType.ZIP,
};

export const AGENCY_GUIDELINES_RESOURCE: MarketingResource = {
  title: 'Linee Guida per le Agenzie Dove.it',
  description: 'Scarica le linee guida per le agenzie fisiche Dove.it sul territorio.',
  fileName: 'Linee guida Agenzie',
  format: FileMimeType.PDF,
};

export const SOCIAL_GUIDELINES_RESOURCE: MarketingResource = {
  title: 'Linee guida social media',
  description: 'Scarica le linee guida social per agenti immobiliari Dove.it ',
  fileName: 'Linee guida Social Media Agenti Dove.it',
  format: FileMimeType.PDF,
};

export const PLAYBOOK_RESOURCE: MarketingResource = {
  title: 'Playbook - Diventa il brand numero 1 nella tua zona',
  description: 'Scarica il Playbook Dove.it per lo sviluppo locale',
  fileName: 'Playbook',
  format: FileMimeType.PDF,
};

export const BROCHURE_AGENT_RECRUITING_RESOURCE: MarketingResource = {
  title: 'Presentazione Dove.it Recruiting - Digitale',
  description: 'Presenta il modello Dove.it e le opportunità di carriera nel nostro team ai futuri agenti.',
  fileName: 'Brochure Recruiting Agenti Dove.it',
  format: FileMimeType.PDF,
};

export const PROPERTY_SHOOTING_RESOURCE: MarketingResource = {
  title: 'Prepara il tuo immobile per lo shooting fotografico ',
  description: 'Linee guida da condividere con il venditore per preparare al meglio l’immobile per lo shooting',
  fileName: 'Prepara il tuo immobile per lo shooting  fotografico - Dove.it',
  format: FileMimeType.PDF,
};

export const STANDARD_MARKETING_RESOURCES: MarketingResource[] = [MARKETING_RESOURCES_CATALOGUE, SOCIAL_GUIDELINES_RESOURCE, SELLERS_SOCIAL_POSTS, RECRUITING_SOCIAL_POSTS, BROCHURE_AGENT_RECRUITING_RESOURCE, EXTRA_PACKAGES_FLYER, AGENCY_GUIDELINES_RESOURCE, DIGITAL_CONSTRUCTOR_PRESENTATION, PRINT_CONSTRUCTOR_PRESENTATION, PLAYBOOK_RESOURCE, PROPERTY_SHOOTING_RESOURCE];

export const PREMIUM_MARKETING_RESOURCES: MarketingResource[] = [MARKETING_RESOURCES_CATALOGUE, EXTRA_PACKAGES_WITH_PREMIUM_VISIBILITY_FLYER, SOCIAL_GUIDELINES_RESOURCE, RECRUITING_SOCIAL_POSTS, BROCHURE_AGENT_RECRUITING_RESOURCE, SELLERS_SOCIAL_POSTS, PRINT_CONSTRUCTOR_PRESENTATION, DIGITAL_CONSTRUCTOR_PRESENTATION, AGENCY_GUIDELINES_RESOURCE, PLAYBOOK_RESOURCE, PROPERTY_SHOOTING_RESOURCE];
